/// <reference types="vite/client" />
import { matchRoutes } from 'react-router-dom';
import {
  initializeFaro,
  createReactRouterV6DataOptions,
  ReactIntegration,
  getWebInstrumentations,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export const initFaro = async () => {
  try {
    // Fetch logging config from /faro-logging-config and use returned JSON to decide if logging is enabled
    // and to set app and env name
    let loggingConfig;
    try {
      const response = await fetch('/faro-logging-config', { method: 'GET' });
      if (!response.ok) {
        // eslint-disable-next-line no-console
        console.log(
          `Could not fetch /faro-logging-config, got status ${response.status}; skipping Faro initialization`,
        );
        return;
      }
      loggingConfig = await response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Failed to fetch /faro-logging-config, skipping Faro initialization:', error);
      return;
    }

    if (!loggingConfig?.enabled) {
      // eslint-disable-next-line no-console
      console.log('Faro logging is disabled based on /faro-logging-config, skipping initialization');
      return;
    }

    const appName = loggingConfig.app_name || 'frontend-react';
    const envName = loggingConfig.env || 'undefined-env';

    // eslint-disable-next-line no-console
    console.log('Initializing Faro with environment:', envName, 'and app:', appName);

    return initializeFaro({
      url: '/faro',
      ignoreUrls: [/.*faro.*/],
      app: {
        name: appName,
        environment: envName,
      },
      batching: {
        enabled: true,
        sendTimeout: 3000,
        itemLimit: 50,
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation(),

        // React integration for React applications.
        new ReactIntegration({
          router: createReactRouterV6DataOptions({
            matchRoutes,
          }),
        }),
      ],
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error initializing Faro:', error);
    return undefined;
  }
};
